import { useEffect } from "react";
import { Link } from "react-router-dom";
import { LogIn, Sparkles, ArrowLeft, Shield } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [loading, user, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen bg-cosmic grid-bg overflow-hidden text-slate-200" data-testid="login-page">
      <div className="absolute inset-0 grid-bg-fine opacity-50 pointer-events-none" />
      <div className="absolute -top-32 left-1/4 w-96 h-96 bg-blue-500/15 rounded-full blur-[140px]" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-500/15 rounded-full blur-[140px]" />

      <Link
        to="/"
        className="absolute top-6 left-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors"
        data-testid="back-home-link"
      >
        <ArrowLeft className="w-4 h-4" />
        Kembali ke beranda
      </Link>

      <div className="relative min-h-screen grid place-items-center px-6">
        <div className="w-full max-w-md">
          {/* Brand */}
          <div className="flex items-center justify-center gap-2.5 mb-8">
            <span className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 grid place-items-center shadow-[0_0_24px_rgba(59,130,246,0.45)]">
              <Sparkles className="w-4 h-4 text-white" strokeWidth={2} />
            </span>
            <div>
              <div className="text-white font-medium" style={{ fontFamily: "Outfit" }}>
                Joneten Saputra
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-blue-400/80 font-mono-display">
                Admin Console
              </div>
            </div>
          </div>

          <div className="rounded-3xl p-8 sm:p-10 glass-elevated corners">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-400/20 mb-5">
              <Shield className="w-3.5 h-3.5 text-blue-300" strokeWidth={1.75} />
              <span className="text-[10px] uppercase tracking-[0.22em] text-blue-200 font-mono-display">
                Admin only
              </span>
            </div>

            <h1
              className="text-2xl sm:text-3xl text-white font-medium tracking-tight"
              style={{ fontFamily: "Outfit" }}
              data-testid="login-title"
            >
              Login ke{" "}
              <span className="text-gradient-aurora">admin panel.</span>
            </h1>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">
              Login menggunakan akun Google yang terdaftar sebagai admin
              (<span className="text-slate-200">joneten91@gmail.com</span>) untuk mengelola artikel blog.
            </p>

            <button
              onClick={handleLogin}
              data-testid="google-login-btn"
              className="group relative mt-7 w-full inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-2xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium shadow-[0_0_30px_rgba(59,130,246,0.4)] hover:shadow-[0_0_55px_rgba(59,130,246,0.6)] transition-shadow overflow-hidden"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-cyan-400/0 via-cyan-300/25 to-cyan-400/0 -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
              <LogIn className="w-4 h-4" strokeWidth={1.75} />
              Lanjut dengan Google
            </button>

            <div className="mt-6 flex items-center gap-3 text-[11px] text-slate-500 font-mono-display">
              <span className="flex-1 h-px bg-white/[0.06]" />
              <span>secured by emergent oauth</span>
              <span className="flex-1 h-px bg-white/[0.06]" />
            </div>
          </div>

          <p className="mt-6 text-center text-xs text-slate-500">
            Hanya akun yang diizinkan yang dapat mengakses admin panel.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
